import { render } from "./temoignages.vue?vue&type=template&id=5706775f"
import script from "./temoignages.vue?vue&type=script&lang=js"
export * from "./temoignages.vue?vue&type=script&lang=js"

import "./temoignages.vue?vue&type=style&index=0&id=5706775f&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__